import { render, staticRenderFns } from "./RegisterAuthCode.vue?vue&type=template&id=16986d5b&"
import script from "./RegisterAuthCode.vue?vue&type=script&lang=ts&"
export * from "./RegisterAuthCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports